import type { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import type { Dispatch } from 'redux';
import { v4 as uuidv4 } from 'uuid';
import { fetchVehicleFunction } from 'domains/catalog/Catalog.requests';

/**
 * Hydrates catalog for an already-known vehicle via `/vehicles/select`
 * (does not consume VIN/VRN search rate limit).
 *
 * @param dispatch - Redux dispatch
 * @param vehicle - Known vehicle detail payload
 * @param includeLatestEstimate - Whether to include the latest estimate for the vehicle
 * @example
 * fetchKnownVehicle(dispatch, vehicleDetail);
 */
export function fetchKnownVehicle(dispatch: Dispatch, vehicle: VehicleDetail, includeLatestEstimate = true): void {
  fetchVehicleFunction(
    dispatch,
    vehicle.vehicleKey,
    includeLatestEstimate,
    vehicle.country,
    vehicle.catalogSource,
    undefined,
    vehicle.iamVehicle?.versionCode,
    vehicle,
    uuidv4(),
  );
}
